import { Component, OnInit } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-unformat-list',
  templateUrl: './unformat-list.component.html',
  styleUrls: ['./unformat-list.component.css']
})
export class UnformatListComponent implements OnInit {

  respObj: any;
  fileData: any;

  perPageRow = this._rest.PER_PAGE_ROW;
  curPage = 1;
  totalRows = 0;
  pages = [];
  noOfRows=0;

  companyId="";
  title="";
  status="";
  fileMonth="";
  fileQuarter="";
  fileYear="";


  downLoadPath=this._rest.FILE_PATH;

  constructor(private router: Router, private _rest: RestapiService) { }

  ngOnInit(): void {
  	this.companyId		=	localStorage.getItem('companyId');
  	this.status			=	'1';
  	this.fileMonth="";
    this.fileQuarter="";
  	this.fileYear="";
  	this.searchFile(1);
  }
  deleteRequest(id){
  	var req 			=	{"id":id};
  	this._rest.delOtherFile(req).subscribe((res) => {
    	this.respObj		=	res;
    	if(this.respObj.error==0){
    		alert("The file is deleted successfully.");
    		this.searchFile(1);
    	}
    });
  }
  searchFile(curPage){
    this.curPage		=	curPage;
    var fd 				= 	{};
    this.fileData		=	[];
	this.totalRows		=	0;
	this.noOfRows		=	0;
	this.pages			=	[];
    fd["limit"]			=	this.perPageRow;
    fd["page"]			=	this.curPage;
    fd["companyId"]		=	this.companyId;
    fd["status"]	=	this.status;

    if(this.title!=""){
    	fd["title"]		=	this.title;
    }
    if(this.fileMonth!=""){
    	fd["month"]		=	this.fileMonth;
    }
    if(this.fileQuarter!=""){
    	fd["quarter"]		=	this.fileQuarter;
    }
    if(this.fileYear!=""){
    	fd["year"]		=	this.fileYear;
    }

    this._rest.getOtherFileList(fd).subscribe((res) => {
    	this.respObj		=	res;
    	if(this.respObj.error==0){
    		this.fileData	=	this.respObj.resp.data;
    		this.totalRows 	= 	this.respObj.resp.info;
		    this.noOfRows	=	this.respObj.resp.data.length;
		    this.pages		=	[];
		    for (var i=1; i<= Math.ceil(this.totalRows/this.perPageRow); i++){
		      this.pages.push(i);
		    }
    	}
    });
    
  }

}
